import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PolicyUserDetails from './PolicyUserDetails';
import PolicyDriver from './PolicyDriver';
import PolicyVehicle from './PolicyVehicle';
import PremiumDetails from './PremiumDetails';
import TransactionHistory from './TransactionHistory';
import PolicyDetail from '../CreatePolicy/PolicyDetail';

const poppinsFont = {
  fontFamily: '"Poppins", sans-serif',
};

const PolicyInfo = ({policyId, selectedRowId, policyData, }) => {
  return (
     <div>
      <Accordion defaultExpanded sx={{ marginBottom: '10px', marginRight:'112px', width: 'calc(100% + 2px)', background:'#F4F5F9', boxShadow: 'none', border: '#D9D9D9 solid 1px', ...poppinsFont }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1header"
          sx={{fontFamily: `"Poppins", sans-serif`,}} 
        >
          Details
        </AccordionSummary>
        <AccordionDetails sx={poppinsFont}>
          <PolicyUserDetails policyData={policyData} selectedRowId={selectedRowId} policy_Id={policyId}/>
        </AccordionDetails>
      </Accordion>

      <Accordion sx={{ margin: '0 0 10px 0', width: 'calc(100% + 2px)', background:'#F4F5F9', boxShadow: 'none', border: '#D9D9D9 solid 1px', ...poppinsFont }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2header"
          sx={{fontFamily: `"Poppins", sans-serif`,}} 
        >
         Policy Details
        </AccordionSummary>
        <AccordionDetails sx={poppinsFont}>
          <PolicyDetail />
        </AccordionDetails>
      </Accordion>


      <Accordion sx={{ margin: '0 0 10px 0', width: 'calc(100% + 2px)', background:'#F4F5F9', boxShadow: 'none', border: '#D9D9D9 solid 1px', ...poppinsFont }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3header"
          sx={{fontFamily: `"Poppins", sans-serif`,}} 
        >
          Drivers
        </AccordionSummary>
        <AccordionDetails sx={poppinsFont}>
          <PolicyDriver policyId={policyId}/>
        </AccordionDetails>
      </Accordion>

      <Accordion sx={{ margin: '0 0 10px 0', width: 'calc(100% + 2px)', background:'#F4F5F9', boxShadow: 'none', border: '#D9D9D9 solid 1px', ...poppinsFont }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4-content"
          id="panel4header"
          sx={{fontFamily: `"Poppins", sans-serif`,}} 
        >
          Vehicle
        </AccordionSummary>
        <AccordionDetails sx={poppinsFont}>
          <PolicyVehicle policyId={policyId} />
        </AccordionDetails>
      </Accordion>

      <Accordion sx={{ margin: '0 0 10px 0', width: 'calc(100% + 2px)', background:'#F4F5F9', boxShadow: 'none', border: '#D9D9D9 solid 1px', ...poppinsFont }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5-content"
          id="panel5header"
          sx={{fontFamily: `"Poppins", sans-serif`,}} 
        >
          Premium
        </AccordionSummary>
        <AccordionDetails sx={poppinsFont}>
          <PremiumDetails policyId={policyId}/>
        </AccordionDetails>
      </Accordion>

      <Accordion sx={{ margin: '0 0 10px 0', width: 'calc(100% + 2px)', background:'#F4F5F9', boxShadow: 'none', border: '#D9D9D9 solid 1px', ...poppinsFont }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6-content"
          id="panel6header"
          sx={{fontFamily: `"Poppins", sans-serif`,}} 
        >
          Transaction History
        </AccordionSummary>
        <AccordionDetails sx={poppinsFont}>
          <TransactionHistory policyId={policyId} />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default PolicyInfo;
